import { render, staticRenderFns } from "./HeySupsis.vue?vue&type=template&id=37571441&scoped=true"
import script from "./HeySupsis.vue?vue&type=script&lang=js"
export * from "./HeySupsis.vue?vue&type=script&lang=js"
import style0 from "./HeySupsis.vue?vue&type=style&index=0&id=37571441&prod&lang=scss"
import style1 from "./HeySupsis.vue?vue&type=style&index=1&id=37571441&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37571441",
  null
  
)

export default component.exports